export const enFooter = {
    "address":"Ali Balhouane Street, Gahbiche Building, 2nd Floor, 4005 Sousse, Tunisia"
}

export const frFooter = {
    "address":"Rue Ali Balhouane, Immeuble Gahbiche, 2ème étage, 4005 Sousse, Tunisie"
}

export const nlFooter = {
    "address": "Ali Balhouane Straat, Gahbiche Gebouw, 2e verdieping, 4005 Sousse, Tunesië"
}

export const deFooter = {
    "address": "Ali Balhouane Straße, Gahbiche Gebäude, 2. Stock, 4005 Sousse, Tunesien"
}